module.exports = __webpack_public_path__ + "img/cgal.3f4a75dd.png";